<script>

/* eslint-disable no-undef */
export default {
    name: 'CalendarFiltersComponent',

    props: {
        calendarUrl: {
            type: String,
            required: true
        },
        searchUrl: {
            type: String,
            required: true
        },
    },

    data() {
        return {
            searchInOccasions: '',
        }
    }
}
</script>

<template>
    <div
        id="calendar-filters-container"
        class="container-fluid calendar-filters"
    >
        <div class="calendar-filter-bg-wrapper">
            <svg class="calendar-filter-bg">
                <use xlink:href="#calendar-filter-bg-new" />
            </svg>
        </div>
        <div class="container position-relative pb-4 pb-sm-5">
            <!-- Filters / Search selector -->
            <div class="d-flex justify-content-between align-items-end pt-5">
                <div class="d-flex align-items-end filter-search-selector text-selection-none">
                    <a
                        class="text-uppercase filter-search-item mr-2"
                        :href="calendarUrl"
                    >
                        {{ __('Advanced search') }}
                    </a>
                    <div
                        class="text-uppercase filter-search-item mx-2 active-view"
                    >
                        {{ __('Search') }}
                    </div>
                </div>
            </div>

            <!-- Search section -->
            <div>
                <div class="row pt-5">
                    <div class="col-12 col-sm-10">
                        <div class="input-group search">
                            <input
                                v-model="searchInOccasions"
                                type="text"
                                class="form-control px-3"
                                :placeholder="__('Search in occasions...')"
                            >
                            <span class="input-group-append d-flex align-items-center">
                                <svg class="icon icon-search"><use xlink:href="#icon-search" /></svg>
                            </span>
                        </div>
                    </div>
                    <div class="col-12 col-sm-2">
                        <a
                            class="btn btn-secondary w-100 ml-2"
                            :href="searchUrl+'?query='+searchInOccasions"
                        >
                            {{ __('Search') }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "./resources/sass/_variables.scss";
@import 'bootstrap/scss/_mixins.scss';

.calendar-filter-bg-wrapper {
    position: absolute;
    right: 0;
    @include media-breakpoint-up(md) {
        left: calc(50vw - 716px);
    }
}

.calendar-filter-bg {
    max-width: 100vw;
    width: 716px;
    height: 309px;
}

.input-group.search {
    padding-top: 5px;
    border-bottom: 1px solid $zh-suplementary-lblue;

    input {
        height: 30px !important;
        color: white;
        outline: none;
        border: none;
        font-size: 20px;
        font-weight: normal;
        margin-bottom: 2px;
        padding-left: 0;
        padding-right: 10px;
        background-color: transparent;
        height: calc(1.8em + 1rem + 2px);

        &:focus {
            box-shadow: none;
            color: white !important;
        }

        &::placeholder {
            color: $zh-suplementary-lblue;
        }

        &:hover {
            color: white;
        }
    }
}

.icon-search {
    --icon-color:  #{$zh-suplementary-lblue};
    width: 20px;
    height: 20px;
}

.filter-search-selector {
    color: white;
    font-size: 12px;
}

.filter-search-item {
    cursor: pointer;
    color: white;
}

.filter-search-item.active-view {
    cursor: default;
    font-size: 20px;
    line-height: 30px;
    border-bottom: 3px solid;
}

.btn {
    font-weight: 400;
}

.btn.btn-secondary.disabled {
    background: transparent;
}

.filter-field-label {
    font-size: 10px;
    text-transform: uppercase;
    color: #B3CFEF;
    padding: 0.5rem 0 0.4rem 1rem;

    .hint {
        text-transform: none;
    }
}
</style>
